import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../config';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }
    try {
      const response = await axios.post(`${BASE_URL}/api/register/`, {
        email,
        password,
      });
      setMessage('Account created successfully!');
      navigate('/login'); 
    } catch (error) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        const messages = Object.entries(data)
          .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
          .join(' | ');
        setMessage(`Registration failed: ${messages}`);
      } else {
        setMessage('Registration failed. Please try again.');
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Create account</h2>
        <p className="auth-subtitle">Join Vegbox today</p>
        <div className="mb-3">
          <label className="auth-label">Email</label>
          <input
            type="email"
            className="form-control auth-input"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Password</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Confirm Password</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onPaste={(e) => e.preventDefault()}
          />
          {confirmPassword && password !== confirmPassword && (
            <p style={{ color: '#e74c3c', fontSize: '0.82rem', marginTop: '4px' }}>Passwords do not match.</p>
          )}
        </div>
        <div className="auth-links">
          <a href="/login">Already have an account? Sign in</a>
        </div>
        <button className="auth-btn" onClick={handleRegister}>
          Create account
        </button>
        {message && <p className="auth-message">{message}</p>}
      </div>
    </div>
  );
};

export default Register;
